export default [
	{
		code: 'retail',
		name: 'Retail',
	},
	{
		code: 'office',
		name: 'Office',
	},
	{
		code: 'industrial',
		name: 'Industrial',
	},
	{
		code: 'other',
		name: 'Other',
	},
]